module.exports = __webpack_public_path__ + "img/miran.ece73c06.png";